import React from 'react'

const Heading = ({ title }) => {
  return <h2 className="title mb-0 mt-3">{title}</h2>
}

export default Heading
